module.exports = __webpack_public_path__ + "static/img/madm-course01.c17b59d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/personRain/madm-course01.jpg
// module id = 22Tr
// module chunks = 2